import { createSlice } from '@reduxjs/toolkit';

const initialOrdersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  orderForView: undefined,
  error: null,
  msg: null,
};
export const callTypes = {
  list: 'list',
  action: 'action',
  create: 'create',
  update: 'update',
  delete: 'delete',
  select: 'select',
};

export const ordersSlice = createSlice({
  name: 'orders',
  initialState: initialOrdersState,
  reducers: {
    catchError: (state, action) => {
      //state.error = `${action.type}: ${action.payload.error}`;
      state.error = `${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    sendMsg: (state, action) => {
      state.msg = `${action.payload.msg}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.msg = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findOrders
    ordersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.msg = null;
      state.entities = entities;
      state.totalCount = totalCount;
      return state;
    },
    // getOrderById
    orderFetched: (state, action) => {
      state.actionsLoading = false;
      state.orderForView = action.payload.orderForView;
      state.error = null;
      state.msg = null;
      return state;
    },
    // create order
    orderCreated: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.orderForView = action.payload.orderForView;
      return state;
    },

    // update Order
    orderUpdated: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.orderForView = action.payload.orderForView;
      return state;
    },
    // delete order
    orderDeleted: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
      return state;
    },
    // create order
    orderCleared: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.orderForView = null;
      return state;
    },
  },
});
